"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Text = exports.NavLink = exports.Wrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _styledSystem = require("styled-system");

var _mediaQueries = _interopRequireDefault(require("../../styles/mediaQueries"));

var _Typography = require("../Typography");

var _Link = _interopRequireDefault(require("../Link"));

var _sharedStyle = require("../../styles/sharedStyle");

var Wrapper = (0, _styled.default)('nav')({
  display: 'flex',
  position: 'relative',
  top: '-1px'
}, function (_ref) {
  var space = _ref.theme.space,
      type = _ref.type;
  return type === 'utility' && {
    marginLeft: "-".concat(space.base)
  };
}, function (_ref2) {
  var _utilityFooter;

  var _ref2$theme = _ref2.theme,
      header = _ref2$theme.header,
      navigation = _ref2$theme.navigation;
  return (0, _styledSystem.variant)({
    prop: 'type',
    variants: {
      utility: {
        top: header.utility.navWrapperTop
      },
      utilityFooter: (_utilityFooter = {}, _defineProperty(_utilityFooter, _mediaQueries.default.untilLarge, {
        flexDirection: navigation.navWrapperFlexDirectionMobile
      }), _defineProperty(_utilityFooter, '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)', {
        width: '100%'
      }), _utilityFooter)
    }
  });
});
exports.Wrapper = Wrapper;
var NavLink = (0, _styled.default)(_Link.default)({
  margin: '0 16px'
}, function (_ref3) {
  var _utilityFooter2;

  var navigation = _ref3.theme.navigation;
  return (0, _styledSystem.variant)({
    prop: 'type',
    variants: {
      utilityFooter: (_utilityFooter2 = {
        margin: navigation.utilityFooterNavLinkMarginMobile
      }, _defineProperty(_utilityFooter2, _mediaQueries.default.large, {
        margin: navigation.utilityFooterNavLinkMarginDesktop
      }), _defineProperty(_utilityFooter2, '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)', {
        flex: navigation.navWrapperFlexDirectionMobile === 'column' ? '0 1 auto' : '0 1 100%'
      }), _utilityFooter2)
    }
  });
});
exports.NavLink = NavLink;
var Text = (0, _styled.default)(_Typography.Body)(function (_ref4) {
  var _ref4$theme = _ref4.theme,
      colors = _ref4$theme.colors,
      header = _ref4$theme.header,
      navigation = _ref4$theme.navigation,
      active = _ref4.active;
  return (0, _styledSystem.variant)({
    prop: 'type',
    variants: {
      primary: (0, _sharedStyle.textHover)({
        accent: colors[header.primary.accent],
        active: active,
        color: colors[header.primary.foreground],
        hover: colors[header.primary.hover],
        activeWeight: header.primary.activeWeight,
        weight: 'bold',
        width: '2px'
      }),
      secondary: (0, _sharedStyle.textHover)({
        accent: colors.secondary,
        active: active,
        color: colors[header.secondary.foreground],
        hover: colors[header.secondary.hover],
        weight: 'bold',
        width: '2px'
      }),
      utility: (0, _sharedStyle.textHover)({
        active: active,
        color: colors[header.utility.foreground],
        hover: colors[header.utility.hover],
        weight: 'bold',
        width: '2px'
      }),
      utilityFooter: _objectSpread(_objectSpread({}, (0, _sharedStyle.textHover)({
        active: active,
        color: colors[header.utilityFooter.foreground],
        hover: colors[header.utilityFooter.hover],
        weight: 'bold'
      })), {}, _defineProperty({}, _mediaQueries.default.untilLarge, {
        fontSize: navigation.utilityFooterTextSizeMobile,
        lineHeight: navigation.utilityFooterLineHeightMobile
      }))
    }
  });
}, function (_ref5) {
  var _ref5$theme = _ref5.theme,
      fonts = _ref5$theme.fonts,
      header = _ref5$theme.header,
      type = _ref5.type;
  return {
    fontFamily: fonts[header[type].font] || fonts.heading
  };
});
exports.Text = Text;